import { Alert, AlertTitle, Snackbar } from "@mui/material";
import * as React from "react";

export function ActionResponseModal(props) {
  const vertical = "top";
  const horizontal = "right";
  return props.isSuccess ? (
    <Snackbar
      aria-label="action-response"
      open={props.isOpen}
      autoHideDuration={10000}
      onClose={props.onClose}
      key={vertical + horizontal}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert
        onClose={props.onClose}
        variant="filled"
        severity="success"
        sx={{ width: "50%" }}
      >
        <AlertTitle> Success!</AlertTitle>
        We have received your Hardware query! You will be notified with updates
        on your Thoughtworks email shortly
      </Alert>
    </Snackbar>
  ) : (
    <Snackbar
      aria-label="action-response"
      open={props.isOpen}
      autoHideDuration={10000}
      onClose={props.onClose}
      key={vertical + horizontal}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert
        onClose={props.onClose}
        variant="filled"
        severity="error"
        sx={{ width: "56.5%" }}
      >
        <AlertTitle> Oops!</AlertTitle>
        Your query was not processed. Something went wrong on our side. Please
        retry after sometime
      </Alert>
    </Snackbar>
  );
}
